
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scansnap-cloud",
      function () {
        return require("private-next-pages/scansnap-cloud.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scansnap-cloud"])
      });
    }
  